export const schemaAlttaHomes = {
    description: "",
    show_in_random_image_home: false,
    random_image_home: "",
    show_in_featured_image_home: false,
    amenities_description: "",
    credits_description: ""
  }